import { PopoverBody } from '@chakra-ui/react'

export default PopoverBody
